import { render, staticRenderFns } from "./ResumoVeiculo.vue?vue&type=template&id=dd922d8c&scoped=true&"
import script from "./ResumoVeiculo.vue?vue&type=script&lang=js&"
export * from "./ResumoVeiculo.vue?vue&type=script&lang=js&"
import style0 from "./ResumoVeiculo.vue?vue&type=style&index=0&id=dd922d8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd922d8c",
  null
  
)

export default component.exports